import { LayoutDashboard, ScrollText, Users, UserCog, Tags, Boxes, type LucideIcon } from 'lucide-react';
import { PERM, useAbility, type Perm } from 'shared/access';

export type AdminNavItem = { id: string; label: string; to: string; icon: LucideIcon; requires: Perm[] };

/*
 * Mirrors the guards in admin/adminRoutes.jsx. Those RequireGroup guards stay:
 * this registry decides what is OFFERED in the sidebar, they decide what is
 * reachable. adminRoutes.jsx gates audit/users/account-execs on 'adminAccess'
 * alone, so this uses ADMIN_MANAGE (adminAccess-only) rather than ADMIN_VIEW
 * (also granted to catalogAuthor) or ADMIN_SKUS (specialPricing's adminOnly
 * SKU flag — unrelated to administration) for those three rows.
 */
export const ADMIN_NAV: AdminNavItem[] = [
  { id: 'dashboard', label: 'Dashboard', to: '/admin', icon: LayoutDashboard, requires: [PERM.ADMIN_VIEW] },
  { id: 'audit', label: 'Audit Log', to: '/admin/audit', icon: ScrollText, requires: [PERM.ADMIN_VIEW, PERM.ADMIN_MANAGE] },
  { id: 'users', label: 'Users & Roles', to: '/admin/users', icon: Users, requires: [PERM.ADMIN_VIEW, PERM.ADMIN_MANAGE] },
  { id: 'accountExecs', label: 'Account Executives', to: '/admin/account-execs', icon: UserCog, requires: [PERM.ADMIN_VIEW, PERM.ADMIN_MANAGE] },
  { id: 'prices', label: 'Prices', to: '/admin/prices', icon: Tags, requires: [PERM.ADMIN_VIEW] },
  { id: 'catalog', label: 'Catalog', to: '/admin/catalog', icon: Boxes, requires: [PERM.CATALOG_AUTHOR] },
];

export function useVisibleAdminNav(): AdminNavItem[] {
  const ability = useAbility();
  return ADMIN_NAV.filter((i) => i.requires.every((p) => ability.can(p)));
}
